import React from 'react';
import SignUpContainer from './container';

const SignUp = props => <SignUpContainer {...props} />;

export default SignUp;
